module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNjY2OTkyIDEwLjgzMzNMMTAuNjY3IDAuODMzMzQ0TTAuNjY2OTkyIDAuODMzMzQ0TDEwLjY2NyAxMC44MzMzIiBzdHJva2U9IiMxQzFDMUMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/website/images/cross-icon.svg
// module id = /3Zy
// module chunks = 0